import axios from "axios";
import { useState } from "react";
import { ArticleInfo } from "../../Modeles/ArticleModel";

export default function AfficheProductsService(id?:any){
    const urlShowProduct = `${process.env.REACT_APP_PHP_APP_URL}/magasins/stock`;
    const urlShowProductByMagasin = `${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/stock`;

      
    const getProduct=()=>{
        return (axios.get(urlShowProduct));
    }
        const getProductByMagasin=()=>{
        return (axios.get(urlShowProductByMagasin));
    }

    const getProductPagination = (page: number) => {
        return axios.get(urlShowProduct, {
          params: {
            page: page,
          },
        });
      };

    return {
        getProductPagination,
        getProduct,
        getProductByMagasin
    }
}